import { IconComponent } from './types';

const CompassIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 0C2.688 0 0 2.688 0 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6Zm0 10.8A4.806 4.806 0 0 1 1.2 6c0-2.646 2.154-4.8 4.8-4.8s4.8 2.154 4.8 4.8-2.154 4.8-4.8 4.8ZM2.7 9.3l4.506-2.094L9.3 2.7 4.794 4.794 2.7 9.3ZM6 5.34c.366 0 .66.294.66.66 0 .366-.294.66-.66.66A.658.658 0 0 1 5.34 6c0-.366.294-.66.66-.66Z"
      fill="currentColor"
    />
  </svg>
);

export default CompassIcon;
